import { StripeError } from '@stripe/stripe-js';
import { CreatePaymentIntentBody } from '@frontend/api-weave-pay';
import { HttpError } from '@frontend/fetch';

export const isStripeCardError = (result: any): result is StripeError =>
  typeof result === 'object' && !!result && 'error' in result;

export type FailurePayment = StripeError | Error | HttpError;
export type FailureHandler = (error: FailurePayment) => void;
export type SuccessPayment = Pick<CreatePaymentIntentBody, 'amount' | 'person'> & { paymentId?: string };
export type SuccessHandler = (paymentDetails: SuccessPayment) => void;
export type DisabledHandler = () => void;
